export default __webpack_public_path__ + "static/media/Untitled_Artwork 21.2a6e3365.png";